const getDifferenceBetweenDatesInDays = (finalDate: number) => {
  const actualDate = Date.now();

  const difference = Math.ceil((finalDate - actualDate) / (1000 * 60 * 60 * 24));
  return difference;
};

export default getDifferenceBetweenDatesInDays;
